var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-inner",class:{'fullscreen': _vm.fullScreen}},[(_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":""}}):_vm._e(),_c('iframe',{ref:"iframe",attrs:{"frameborder":"0","src":"about:blank"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }